/** biome-ignore-all lint/suspicious/noExplicitAny: temporary */
import { z } from 'zod';

import { columnRef, inputDataset } from '#core/components/dashboard/schema.dataset.ts';
import { ItemBase, Threshold, ValueFormat } from '#core/components/dashboard/schema.primitives.ts';

// /**
//  * Trend direction for KPI value changes.
//  */
// export const KPI_TRENDS = ['up', 'down', 'neutral'] as const;
//
// export type KpiTrend = (typeof KPI_TRENDS)[number];
//
// /**
//  * Alert variants for KPI display.
//  * - emergency: Pulsing red glow with alert icon (critical alerts)
//  * - corrective: Orange/yellow gradient (action required)
//  * - preventive: Blue gradient (informational warning)
//  */
// export const KPI_KINDS = ['emergency', 'corrective', 'preventive'] as const;
//
// export type KpiKind = (typeof KPI_KINDS)[number];

// export const KpiDataSchema = z.object({
//   value: z.union([z.number(), z.string()]).describe('The primary metric value to display prominently'),
//   label: z.string().describe('Label describing what the value represents'),
//   unit: z.string().optional().describe('Unit of measurement (e.g., "kWh", "%", "items")'),
//   trend: z
//     .enum(KPI_TRENDS)
//     .optional()
//     .describe('Direction indicator: up (positive change), down (negative), neutral (no change)'),
//   trendValue: z.number().optional().describe('Percentage or absolute change value to display with trend'),
// });
//
// export type KpiData = z.infer<typeof KpiDataSchema>;

export const KpiData = z.object({
  value: columnRef.describe('Numeric column. Latest non-null value is displayed.'),
  delta: columnRef
    .optional()
    .describe(
      'Optional numeric column. Latest non-null value is shown as the delta. ' +
        'When omitted and `sparkline` is set, delta is auto-derived from the last two sparkline points.',
    ),
  sparkline: z
    .object({ x: columnRef, y: columnRef })
    .optional()
    .describe('Inline mini-trend. Presence auto-renders the sparkline; absence hides it.'),
});

export const KpiSchema = ItemBase.extend({
  type: z.literal('kpi'),
  inputDataset,
  data: KpiData,
  format: ValueFormat.default('number'),
  unit: z.string().optional().describe('Value suffix, e.g. "req/s".'),
  deltaPeriod: z.string().optional().describe('Period descriptor shown alongside delta, e.g. "vs last week".'),
  deltaDirection: z.enum(['higher-is-good', 'lower-is-good', 'neutral']).default('higher-is-good'),
  thresholds: Threshold.array().max(4).optional().describe('Alert breakpoints applied to the displayed value.'),
});

// export const KpiSchema = z.object({
//   type: z.literal('kpi').describe('KPI component type'),
//   value: z.union([z.number(), z.string()]).describe('Primary metric value to display'),
//   label: z.string().describe('Short ~5-word label describing the metric'),
//   unit: z.string().optional().describe('Unit of measurement (e.g., "kWh", "%", "items")'),
//   trend: z.enum(KPI_TRENDS).optional().describe('Trend direction: up, down, or neutral'),
//   trendValue: z.number().optional().describe('Change percentage to display with trend'),
//   color: ColorSchema.optional().describe(
//     'Alert background color (e.g., "red", "orange", "green"). Enables alert-style display',
//   ),
//   kind: z
//     .enum(KPI_KINDS)
//     .optional()
//     .describe('Alert variant: "emergency" (pulsing red with icon), "corrective" (orange), "preventive" (blue)'),
//   decimalScale: z
//     .number()
//     .optional()
//     .describe('Decimal places for numeric values (default: 2 for standard, 1 for alert)'),
// });

/** @public Input type for KpiSchema - use for component props */
export type KpiSchemaInput = z.input<typeof KpiSchema>;

/** @public Output type for KpiSchema - use after Zod parsing */
export type KpiSchemaOutput = z.output<typeof KpiSchema>;
